import { render, staticRenderFns } from "./Chara.vue?vue&type=template&id=135d9659&scoped=true&"
import script from "./Chara.vue?vue&type=script&lang=js&"
export * from "./Chara.vue?vue&type=script&lang=js&"
import style0 from "./Chara.vue?vue&type=style&index=0&id=135d9659&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d9659",
  null
  
)

export default component.exports